import type { CompassComponentLink } from '../../types';

export const isCompassComponentLink = (entity: any): entity is CompassComponentLink =>
	entity.__typename === 'CompassLinkNode';

export const getCompassComponentLinkLink = (link: CompassComponentLink): string | null =>
	link?.url ?? null;
